var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.309,
    height: 22.934,
    viewBox: "0 0 24.309 22.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material",
    transform: "translate(0 -14.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1429",
    "data-name": "Caminho 1429",
    d: "M24.309,20.448a.475.475,0,0,0-.273-.43l-4.364-2.054a.475.475,0,1,0-.4.859l3.451,1.624L12.155,25.419,1.59,20.448l10.565-4.972L15.5,17.052a.475.475,0,1,0,.4-.859l-3.551-1.671a.474.474,0,0,0-.4,0l-11.68,5.5a.475.475,0,0,0,0,.859L5.2,23.2.273,25.514a.475.475,0,0,0,0,.859L5.2,28.692.273,31.011a.475.475,0,0,0,0,.859l11.68,5.5a.478.478,0,0,0,.4,0l11.679-5.5a.475.475,0,0,0,0-.859l-4.927-2.319,4.927-2.319a.475.475,0,0,0,0-.859L19.109,23.2l4.927-2.319A.475.475,0,0,0,24.309,20.448Zm-13.27,5.5L6.315,28.167,4.48,27.3l4.773-2.2ZM7.43,28.692l4.926-2.318h0l5.638-2.653,1.806.85L9.129,29.492ZM6.315,23.721l1.816.854-4.773,2.2L1.59,25.944Zm11.68,5.5,4.724,2.224L12.155,36.412,1.59,31.44l4.725-2.224,5.638,2.653a.479.479,0,0,0,.4,0Zm-5.84,1.7-1.9-.9L20.923,25.1l1.8.845Z",
    transform: "translate(0 0)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1430",
    "data-name": "Caminho 1430",
    d: "M110.46,356.535l-.973-.5a.475.475,0,1,0-.432.845l.973.5a.475.475,0,1,0,.432-.845Z",
    transform: "translate(-103.63 -325.294)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1431",
    "data-name": "Caminho 1431",
    d: "M173.919,387.214l-.973-.5a.475.475,0,1,0-.432.845l.973.5a.475.475,0,0,0,.432-.845Z",
    transform: "translate(-164.076 -354.517)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1432",
    "data-name": "Caminho 1432",
    d: "M236.765,417.6a.475.475,0,0,0,.207.639l.973.5a.475.475,0,1,0,.432-.845l-.973-.5A.475.475,0,0,0,236.765,417.6Z",
    transform: "translate(-225.474 -383.739)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1433",
    "data-name": "Caminho 1433",
    d: "M296.465,388.56l.973.5a.475.475,0,0,0,.432-.845l-.973-.5a.475.475,0,1,0-.432.845Z",
    transform: "translate(-282.143 -355.467)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1434",
    "data-name": "Caminho 1434",
    d: "M355.959,358.878l.973.5a.475.475,0,1,0,.432-.845l-.973-.5a.475.475,0,1,0-.432.845Z",
    transform: "translate(-338.812 -327.194)",
    fill: "#640000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1435",
    "data-name": "Caminho 1435",
    d: "M361.367,69.37a.475.475,0,1,0,.076-.615A.479.479,0,0,0,361.367,69.37Z",
    transform: "translate(-344.135 -51.587)",
    fill: "#640000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.48616d8fa7ef820a56067ae0f3cf9c48.svg";
export { ForwardRef as ReactComponent };